const ALL_SALES = 'All Sales';
const APP = 'App';
export { ALL_SALES, APP };